import commonAppEssayData from './common-app-essay-content.json';
import type { CommonAppEssayContent } from './types';

export * from './types';

export const commonAppEssayContent = commonAppEssayData as CommonAppEssayContent;
